import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from '../../styles.module.css';

const bem = getBem(styles);

<template>
  <div class={{bem 'content'}} ...attributes>
    {{#unless @contentItem.isPlaceholder}}
      <h3 class={{bem 'title'}}>
        {{@contentItem.displayHeadline}}
        {{#if @contentItem.contentItemId}}
          ({{@contentItem.contentItemId}})
        {{/if}}
      </h3>
    {{/unless}}
  </div>
</template>
